import '../Page.css';
import './Panel.css';
export var panelBaseCSS = '_ix3k072-2-0-1';
export var resizeHandleCSS = '_ix3k071-2-0-1';
export var resizerCSS = '_ix3k070-2-0-1';